import { useQuery } from "@tanstack/react-query"
import { conversationGoalsQuery } from "../../../lib/goals/conversationGoalsQuery"

export function useConversationGoalsQuery(...args: Parameters<typeof conversationGoalsQuery>) {
  return useQuery(conversationGoalsQuery(...args))
}
